import { Routes } from '@angular/router';

export const entityRoutes: Routes = [
  // Brand Type
  {
    path: 'brand-type',
    data: { moduleCode: 'brd_type' },
    children: [
      { path: '', loadComponent: () => import('./brand-type/brand-type').then((m) => m.BrandType) },
      { path: 'add', loadComponent: () => import('./brand-type/brand-type-details/brand-type-details').then((m) => m.BrandTypeDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./brand-type/brand-type-details/brand-type-details').then((m) => m.BrandTypeDetails)
      }
    ]
  },

  // Business Type
  {
    path: 'business-type',
    data: { moduleCode: 'busi_type' },
    children: [
      { path: '', loadComponent: () => import('./business-type/business-type').then((m) => m.BusinessType) },
      { path: 'add', loadComponent: () => import('./business-type/business-details/business-details').then((m) => m.BusinessDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./business-type/business-details/business-details').then((m) => m.BusinessDetails)
      }
    ]
  },

  // Store Grouping
  {
    path: 'store-grouping',
    data: { moduleCode: 'store_grp' },
    children: [
      { path: '', loadComponent: () => import('./store-grouping/store-grouping').then((m) => m.StoreGrouping) },
      {
        path: 'add',
        loadComponent: () => import('./store-grouping/store-grouping-details/store-grouping-details').then((m) => m.StoreGroupingDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./store-grouping/store-grouping-details/store-grouping-details').then((m) => m.StoreGroupingDetails)
      }
    ]
  },

  // Entity Profile
  {
    path: 'entity',
    data: { moduleCode: 'ent_pro' },
    children: [
      { path: '', loadComponent: () => import('./entity-profile/entity-profile').then((m) => m.EntityProfile) },
      { path: 'add', loadComponent: () => import('./entity-profile/entity-add/entity-add').then((m) => m.EntityAdd) },
      { path: 'onboard', loadComponent: () => import('./onboard/onboard').then((m) => m.Onboard) },
      { path: 'details/:id', loadComponent: () => import('./entity-profile/entity-details/entity-details').then((m) => m.EntityDetails) },
      {
        path: 'import',
        loadComponent: () => import('./entity-profile/entity-import/entity-import').then((m) => m.EntityImport)
      }
    ]
  },
  // New Entity Req
  {
    path: 'new-entity',
    data: { moduleCode: 'ent_new_ent' },
    children: [
      { path: '', loadComponent: () => import('./new-entity-req/new-entity-req').then((m) => m.NewEntityReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./new-entity-req/new-entity-req-details/new-entity-req-details').then((m) => m.NewEntityReqDetails)
      }
    ]
  },
  // Update Entity Req
  {
    path: 'entity-details-update-request',
    data: { moduleCode: 'ent_details_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-entity-req/update-entity-req').then((m) => m.UpdateEntityReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-entity-req/update-entity-req-details/update-entity-req-details').then((m) => m.UpdateEntityReqDetails)
      }
    ]
  },
  // Warehouse Profile
  {
    path: 'warehouse-profile',
    data: { moduleCode: 'ware_pro' },
    children: [
      { path: '', loadComponent: () => import('./warehouse-profile/warehouse-profile').then((m) => m.WarehouseProfile) },
      { path: 'add', loadComponent: () => import('./warehouse-profile/warehouse-add/warehouse-add').then((m) => m.WarehouseAdd) },
      {
        path: 'details/:id',
        loadComponent: () => import('./warehouse-profile/warehouse-details/warehouse-details').then((m) => m.WarehouseDetails)
      },
      {
        path: 'import',
        loadComponent: () => import('./warehouse-profile/warehouse-import/warehouse-import').then((m) => m.WarehouseImport)
      }
    ]
  },
  // New Warehouse Req
  {
    path: 'new-warehouse',
    data: { moduleCode: 'ent_new_ware' },
    children: [
      { path: '', loadComponent: () => import('./new-warehouse-req/new-warehouse-req').then((m) => m.NewWarehouseReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./new-warehouse-req/new-warehouse-req-details/new-warehouse-req-details').then((m) => m.NewWarehouseReqDetails)
      }
    ]
  },
  // Update Warehouse Req
  {
    path: 'warehouse-details-update-request',
    data: { moduleCode: 'ent_ware_details_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-warehouse-req/update-warehouse-req').then((m) => m.UpdateWarehouseReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-warehouse-req/update-warehouse-req-details/update-warehouse-req-details').then(
            (m) => m.UpdateWarehouseReqDetails
          )
      }
    ]
  },
  // Terminal Profile
  {
    path: 'terminal-profile',
    data: { moduleCode: 'term_pro' },
    children: [
      { path: '', loadComponent: () => import('./terminal-profile/terminal-profile').then((m) => m.TerminalProfile) },
      { path: 'add', loadComponent: () => import('./terminal-profile/terminal-add/terminal-add').then((m) => m.TerminalAdd) },
      {
        path: 'details/:id',
        loadComponent: () => import('./terminal-profile/terminal-details/terminal-details').then((m) => m.TerminalDetails)
      },
      { path: 'import', loadComponent: () => import('./terminal-profile/terminal-import/terminal-import').then((m) => m.TerminalImport) }
    ]
  },
  // New Terminal Req
  {
    path: 'new-terminal',
    data: { moduleCode: 'ent_new_terminal' },
    children: [
      { path: '', loadComponent: () => import('./new-terminal-req/new-terminal-req').then((m) => m.NewTerminalReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./new-terminal-req/new-terminal-req-details/new-terminal-req-details').then((m) => m.NewTerminalReqDetails)
      }
    ]
  },
  // Update Terminal Req
  {
    path: 'terminal-details-update-request',
    data: { moduleCode: 'ent_terminal_details_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-terminal-req/update-terminal-req').then((m) => m.UpdateTerminalReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-terminal-req/update-terminal-req-details/update-terminal-req-details').then((m) => m.UpdateTerminalReqDetails)
      }
    ]
  },
  // Store Profile
  {
    path: 'store-profile',
    data: { moduleCode: 'store_pro' },
    children: [
      { path: '', loadComponent: () => import('./store-profile/store-profile').then((m) => m.StoreProfile) },
      { path: 'add', loadComponent: () => import('./store-profile/store-add/store-add').then((m) => m.StoreAdd) },
      { path: 'details/:id', loadComponent: () => import('./store-profile/store-details/store-details').then((m) => m.StoreDetails) },
      { path: 'import', loadComponent: () => import('./store-profile/store-import/store-import').then((m) => m.StoreImport) }
    ]
  },
  // New Store Req
  {
    path: 'new-store',
    data: { moduleCode: 'ent_new_store' },
    children: [
      { path: '', loadComponent: () => import('./new-store-req/new-store-req').then((m) => m.NewStoreReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./new-store-req/new-store-req-details/new-store-req-details').then((m) => m.NewStoreReqDetails)
      }
    ]
  },
  // Update Store Req
  {
    path: 'store-details-update-request',
    data: { moduleCode: 'ent_store_details_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-store-req/update-store-req').then((m) => m.UpdateStoreReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./update-store-req/update-store-req-details/update-store-req-details').then((m) => m.UpdateStoreReqDetails)
      }
    ]
  },
  // Reorder Group
  {
    path: 'reorder-group',
    data: { moduleCode: 'reorder_grp' },
    children: [
      { path: '', loadComponent: () => import('./reorder-group/reorder-group').then((m) => m.ReorderGroup) },
      {
        path: 'add',
        loadComponent: () => import('./reorder-group/reorder-group-details/reorder-group-details').then((m) => m.ReorderGroupDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./reorder-group/reorder-group-details/reorder-group-details').then((m) => m.ReorderGroupDetails)
      }
    ]
  },
  // RQNQ Value Change
  {
    path: 'rqnq-value-change',
    data: { moduleCode: 'ent_rqnq_value_change' },
    children: [
      { path: '', loadComponent: () => import('./rqnq-value-change/rqnq-value-change').then((m) => m.RqnqValueChange) },
      {
        path: 'add',
        loadComponent: () =>
          import('./rqnq-value-change/rqnq-value-change-details/rqnq-value-change-details').then((m) => m.RqnqValueChangeDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./rqnq-value-change/rqnq-value-change-details/rqnq-value-change-details').then((m) => m.RqnqValueChangeDetails)
      }
    ]
  }
];
